import 'react-activity-indicator/src/activityindicator.css';

import ActivityIndicatorPlain from 'react-activity-indicator';

const ActivityIndicator = ({ ...props }) => (
  <ActivityIndicatorPlain
    activeColor="#66D9EF"
    borderColor="white"
    borderRadius="50%"
    borderWidth={1}
    diameter={20}
    duration={300}
    number={5}
    {...props}
  />
);

export default ActivityIndicator;
